import { NewsResponse } from '../types/news';
import { instanceWithV2 as instance } from './SimpleAPIClient';
import CONFIG from '../config/config';

class NewsAPI {

  async getNews(locale: string, limit: number = 5, offset: number = 0): Promise<NewsResponse> {
    const response = await instance(CONFIG.API_ENDPOINT).get(`/v1/news?locale=${locale}&limit=${limit}&offset=${offset}`);
    return response.data;
  }

  async markAsViewedByIdentifier(newsIdentifier: string): Promise<void> {
    // First we need to get the news by identifier to find its ID
    // For now, we'll keep the old endpoint until we can update the logic
    await instance(CONFIG.API_ENDPOINT).post(`/v1/news/identifier/${newsIdentifier}/view`, {});
  }

  async markAsViewedById(newsId: number): Promise<void> {
    await instance(CONFIG.API_ENDPOINT).post(`/v1/news/${newsId}/view`, {});
  }

  extractNewsIdentifier(news: any): string | null {
    return news.newsIdentifier || null;
  }

}

const newsAPI = new NewsAPI();
export default newsAPI;
